import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import useSWR from 'swr';

import { I_Badge } from 'containers/Badge/interface';
import { IDetailResponse, IPaginatedResponse } from 'utils/types';

import { fetcher } from './utils';

export const useBadge = (id?: number | string | null) => {
  const { data, isLoading, error, mutate, isValidating } = useSWR<IDetailResponse<I_Badge>>(
    id ? `/v4/dash/badges/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, error, mutate, isValidating };
};

export const useBadgeList = (params: Record<string, any>) => {
  const sanitizedParams = omitBy(params, isNil);
  const key = { url: '/v4/dash/badges', params: sanitizedParams };
  const { data, isLoading, error, mutate, isValidating } = useSWR<IPaginatedResponse<I_Badge>>(
    key,
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, error, mutate, isValidating };
};
